import dayjs from "dayjs";
import { REPORT } from "../utils/Struct";
import { getDefaultColumns } from "../components/ReportColumns";
import { getDefaultCustomerColumns } from "../components/CustomerColumns";

export const getInventoryReportTemplate = (_template_id, _group) => {

    let _ret = { ...REPORT };

    _ret.group = _group;
    _ret.columns = getDefaultColumns().map((item, index) => {
        return ({
            "position": index,
            "column_id": (item?.filter_id) ? item.filter_id : "",
            "display_name": item.title,
            "size": Math.ceil(item.width),
            "type": item.value
        })
    });

    switch (_template_id) {
        // Empty
        case 1:

            _ret.filters = [
                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 0,
                    "type": 35,
                    "value_1": "",
                    "value_2": "",
                    "where_type": "NOT"
                }
            ]
            break;

        case 2:
            _ret.name = "Sales";
            _ret.scope_type = 2;
            _ret.order_1 = 14;
            _ret.filters = [
                {
                    "filter_id": "",
                    "comparison": "",
                    "ordering": 0,
                    "type": -5,
                    "value_1": dayjs().add(-1, "day").format("YYYY-MM-DD") + " 00:00:00",
                    "value_2": dayjs().format("YYYY-MM-DD") + " 23:59:00",
                    "where_type": "AND"
                },

                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 1,
                    "type": -7,
                    "value_1": "S|H|A|P|F",
                    "value_2": "",
                    "where_type": "AND"
                },

                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 0,
                    "type": 35,
                    "value_1": "",
                    "value_2": "",
                    "where_type": "NOT"
                },
                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 1,
                    "type": 43,
                    "value_1": "",
                    "value_2": "",
                    "where_type": "NOT"
                }
            ]
            break;

        case 3:
            _ret.name = "Backroom stock needed on floor";
            //_ret.scope_type = 2;
            //_ret.order_1 = 14;
            _ret.columns = [
                {
                    "column_id": "",
                    "display_name": "Supl",
                    "position": 0,
                    "size": 48,
                    "type": 41
                },
                {
                    "column_id": "",
                    "display_name": "Class",
                    "position": 1,
                    "size": 85,
                    "type": 7
                },
                {
                    "column_id": "",
                    "display_name": "Floor",
                    "position": 2,
                    "size": 67,
                    "type": 52
                },
                {
                    "column_id": "",
                    "display_name": "Back",
                    "position": 3,
                    "size": 48,
                    "type": 5
                },
                {
                    "column_id": "",
                    "display_name": "Title",
                    "position": 4,
                    "size": 356,
                    "type": 42
                },
                {
                    "column_id": "",
                    "display_name": "Author",
                    "position": 5,
                    "size": 244,
                    "type": 4
                },
                {
                    "column_id": "",
                    "display_name": "ISBN",
                    "position": 6,
                    "size": 160,
                    "type": 11
                },
                {
                    "column_id": "",
                    "display_name": "Price",
                    "position": 7,
                    "size": 76,
                    "type": 25
                },
                {
                    "column_id": "",
                    "display_name": " JUL AUG SEP OCT NOV DEC JAN FEB MAR APR MAY JUN JUL AUG",
                    "position": 8,
                    "size": 534,
                    "type": 37
                }
            ]
            _ret.filters = [

                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 1,
                    "type": 57,
                    "value_1": "",
                    "value_2": "",
                    "where_type": "AND"
                },
                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 0,
                    "type": 35,
                    "value_1": "",
                    "value_2": "",
                    "where_type": "NOT"
                }

            ]
        default:
            break;

    }


    return _ret;

}


export const getCustomerReportTemplate = (_template_id, _group) => {

    let _ret = { ...REPORT };

    _ret.group = _group;
    _ret.columns = getDefaultColumns().map((item, index) => {
        return ({
            "position": index,
            "column_id": (item?.filter_id) ? item.filter_id : "",
            "display_name": item.title,
            "size": Math.ceil(item.width),
            "type": item.value
        })
    });

    switch (_template_id) {
        // Empty
        case 1:

            _ret.filters = [
                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 0,
                    "type": 35,
                    "value_1": "",
                    "value_2": "",
                    "where_type": "NOT"
                }
            ]
            break;

        case 2:
            _ret.name = "Sales";
            _ret.scope_type = 2;
            _ret.order_1 = 14;
            _ret.filters = [
                {
                    "filter_id": "",
                    "comparison": "",
                    "ordering": 0,
                    "type": -5,
                    "value_1": dayjs().add(-1, "day").format("YYYY-MM-DD") + " 00:00:00",
                    "value_2": dayjs().format("YYYY-MM-DD") + " 23:59:00",
                    "where_type": "AND"
                },

                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 1,
                    "type": -7,
                    "value_1": "S|H|A|P|F",
                    "value_2": "",
                    "where_type": "AND"
                },

                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 0,
                    "type": 35,
                    "value_1": "",
                    "value_2": "",
                    "where_type": "NOT"
                },
                {
                    "comparison": "",
                    "filter_id": "",
                    "ordering": 1,
                    "type": 43,
                    "value_1": "",
                    "value_2": "",
                    "where_type": "NOT"
                }
            ]
            break;

        case 3:
            _ret.name = "Customers";
            _ret.columns = getDefaultCustomerColumns().map((item, index) => {
                return ({
                    "position": index,
                    "column_id": (item?.filter_id) ? item.filter_id : "",
                    "display_name": item.title,
                    "size": Math.ceil(item.width),
                    "type": item.value
                })
            });
            _ret.filters = []


        default:
            break;

    }


    return _ret;

}


